<template>
	<card class="edit-grid-card">
		<loader :loading="loading"></loader>
		<h4 class="title">
			<slot name="title"></slot>
			<transition name="fade" mode="out-in">
				<div class="actions" v-if="viewing" key="view-actions">
					<icon-action @click="viewing = null">essentials/basics/close-circle</icon-action>
				</div>
				<div class="actions" v-else-if="user.can(permission) && !editing && !editOnly" key="edit-actions">
					<icon-action @click="setEdit(defaultObj || {})">essentials/basics/add-circle</icon-action>
				</div>
				<div class="actions" v-else-if="user.can(permission) && (editing || editOnly)" key="save-actions">
					<icon-action @click="editing = null; $emit('cancel')" v-if="!editOnly">essentials/basics/close-circle</icon-action>
					<icon-action @click="doSave">essentials/basics/check-circle</icon-action>
				</div>
			</transition>
		</h4>
		<transition name="fade" mode="out-in">
			<div class="content" v-if="viewing" key="single-content">
				<slot name="single" :viewing="viewing"></slot>
			</div>
			<div class="content" v-else-if="editing" key="edit-content" @keyup.enter.prevent.stop="doSave">
				<slot name="edit" :editing="editing"></slot>
			</div>
			<div class="content" v-else="!editing && !editOnly" key="view-content">
				<slot name="view" :edit="setEdit" :view="setView"></slot>
			</div>
		</transition>
		<slot></slot>
	</card>
</template>

<script>
	export default {
		props: ['permission', 'save', 'editOnly', 'addHandler', 'defaultObj'],
		data() {
			return {
				editing: null,
				viewing: null,
				loading: false
			};
		},
		computed: {
			user() {
				return this.$store.state.user;
			}
		},
		methods: {
			setView(obj) {
				this.viewing = this.$clone(obj);
			},
			setEdit(obj) {
				if(typeof(this.addHandler) === 'function') {
					this.addHandler();
					return;
				}
				this.editing = this.$clone(obj);
			},
			async doSave() {
				if(!this.save) {
					return;
				}
				this.loading = true;
				try {
					await this.save(this.editing);
					this.editing = null;
				} catch(e) {}
				this.loading = false;
			}
		}
	}
</script>